import React from 'react';
import T from 'prop-types';
// components
import Icon from '../../../components/Icon/Icon';
import ShrinkedText from '../../../components/ShrinkedText/ShrinkedText';
// styles
import styles from './ModuleProgress.mod.css';
import classnames from 'classnames/bind';

const cn = classnames.bind(styles);

const getLeftIcon = ({ done, current, lock }) => {
  if (done) {
    return 'check-circle';
  }
  if (current) {
    return 'pen-in-circle';
  }
  if (lock) {
    return 'lock';
  }
};

const getStepIcon = type =>
  type === 'lecture' || type === 'summary_value' ? 'file' : type;

const ModuleProgress = ({
  steps,
  title,
  currentStep,
  activeStep,
  isCompleted,
  setActiveStep,
  isTablet
}) => (
  <div
    className={cn(styles.progressContainer, {
      horizontal: isTablet,
      tablet: isTablet
    })}
  >
    <div className={styles.tasks}>
      {steps.map((step, index) => {
        const stepState = {
          done: currentStep > index || isCompleted,
          current: currentStep === index && !isCompleted,
          active: activeStep === index,
          lock: currentStep < index && !isCompleted
        };
        const leftIcon = getLeftIcon(stepState);
        const title = step.content.title || step.title || step.step_type;

        return (
          <div
            onClick={() => !stepState.lock && setActiveStep(index)}
            key={index}
            className={cn('task', stepState, {
              'title-tall': title.length >= 12,
              'title-slim': title.length < 12
            })}
          >
            <Icon type={leftIcon} className={styles.leftIcon} />
            <Icon type={getStepIcon(step.step_type)} className={styles.icon} />

            <ShrinkedText className={cn('title')} length={19}>
              {title}
            </ShrinkedText>
          </div>
        );
      })}
    </div>
  </div>
);

ModuleProgress.propTypes = {
  data: T.shape({
    title: T.string.isRequired,
    currentStep: T.number,
    isCompleted: T.bool.isRequired,
    tasks: T.arrayOf(
      T.shape({
        type: T.oneOf(['lecture', 'video', 'quiz', 'input', 'slideshow'])
          .isRequired
      })
    )
  })
};

export default ModuleProgress;



// WEBPACK FOOTER //
// ./src/containers/Module/components/ModuleProgress.jsx